<template>
    <div class="mt-2">
      <!-- start: page -->
      <div class="tabs">
        
        <div class="tab-content">
          <!-- novi superbonus -->
          <div id="super-bonus" class="tab-pane active">
            <form
              class="ecommerce-form action-buttons-fixed"
              @submit.prevent="submitsuperBonus"
            >
              <div class="row">
                <div class="col">
                  <!-- superbonus -->
                    <section class="card card-modern card-big-info mt-2">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-lg-2-5 col-xl-1-5">
                            <i class="card-big-info-icon bx bx-slider"></i>
                            <h2 class="card-big-info-title">
                              Super bonus program
                            </h2>
                            <p class="card-big-info-desc">
                              Ažuriraj super bonus program
                            </p>
                          </div>
                          <div class="col-lg-3-5 col-xl-4-5">
  
                            <!-- Super Bonus Progress Bar -->
    <div v-if="superBonus && superBonus.ranges
    && superBonus.ranges.length > 0" class="feature-box progress-bar-wrapper mb-4">
      <p class="super-bonus-title">Super Bonus program</p>
      <div class="progress-bar-container">
        <div class="progress-bar">
          <div
          class="progress-fill"
          :style="{ width: progressWidth + '%' }"
          ></div>
        </div>
        <div
          class="current-amount-tooltip"
          :style="{ left: progressWidth + '%' }"
        >
          {{ formattedCurrentAmount() }}
        </div>

        <div
          v-for="(milestone, index) in superBonus.ranges"
          :key="index"
          class="milestone"
          :style="{ left: calculateSuperbonusProgress(milestone.maxAmount) + '%' }"
        >
          <div
            class="milestone-circle"
            :class="{ 'active': progressPercentage
            >= calculateSuperbonusProgress(milestone.maxAmount) }"
          >
            {{ milestone.discount }}%
          </div>
          <div class="milestone-value">
            {{ milestone.maxAmount }}
          </div>
        </div>

      </div>
    </div>
  
                            <div
                              class="form-group row align-items-center pb-3 pt-3"
                              :class="{ 'has-danger': $v.superBonus.dateFrom.$anyError }">
                              <label
                                class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                                >Vrijedi od</label
                              >
                              <div class="col-lg-7 col-xl-6">
                                <datepicker
                                  input-class="form-control form-control-modern bg-body"
                                  :monday-first="true"
                                  :full-month-name="true"
                                  :language="bs"
                                  :format="customFormatter"
                                  v-model="superBonus.dateFrom"
                                ></datepicker>
  
                                <form-error
                                  :model="$v.superBonus.dateFrom"
                                  label="Vrijedi od"
                                  :dirty="$v.superBonus.$dirty"
                                />
                              </div>
                            </div>
  
                            <div
                              class="form-group row align-items-center pb-3"
                              :class="{ 'has-danger': $v.superBonus.dateTo.$anyError }">
                              <label
                                class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                                >Vrijedi do</label
                              >
                              <div class="col-lg-7 col-xl-6">
                                <datepicker
                                  input-class="form-control form-control-modern bg-body"
                                  :monday-first="true"
                                  :full-month-name="true"
                                  :language="bs"
                                  :format="customFormatter"
                                  v-model="superBonus.dateTo"
                                ></datepicker>
                                <form-error
                                  :model="$v.superBonus.dateTo"
                                  label="Vrijedi do"
                                  :dirty="$v.superBonus.$dirty"
                                />
                              </div>
                            </div>
  
                            <!-- <div class="d-flex justify-content-end">
                              <button
                                type="submit"
                                class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                                data-loading-text="Loading..."
                              >
                                <i class="bx bx-save text-4 me-2"></i> Aktiviraj super bonus program
                              </button>
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </section>
                  <!-- kraj superbonus -->
                </div>
              </div>
              <div class="row mt-2">
                <div class="col">
                  <div class="card card-modern card-modern-table-over-header">
                    <div class="card-header">
                      <div class="row align-items-center mb-5">
                        <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                          <a
                            @click="openAddRangeModal"
                            class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim me-1"
                          >
                            + Dodaj stavku
                          </a>
                          <button
                            class="btn btn-warning btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim"
                            type="button"
                            @click.prevent.stop="showConfirmationModal"
                          >
                            - Ukloni stavku
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body" style="margin-top: -20px">
                      <table
                        v-if="
                          superBonus.ranges &&
                          superBonus.ranges.length
                        "
                        class="table table-offer table-ecommerce-simple table-borderless table-striped mb-0"
                        style="min-width: 640px"
                      >
                        <thead>
                          <tr>
                            <th width="30">
                              <input
                                type="checkbox"
                                class="select-all checkbox-style-1 p-relative top-2"
                                v-model="selectAll"
                              />
                            </th>
                            <th>RBR</th>
                            <th>Min vrijednost</th>
                            <th>Max vrijednost</th>
                            <th>Rabat</th>
                            <!-- <th>Akcije</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in superBonus.ranges"
                            :key="item.generatedId"
                          >
                            <td width="30">
                              <input
                                type="checkbox"
                                class="checkbox-style-1 p-relative top-2"
                                :value="item.generatedId"
                                v-model="selected"
                              />
                            </td>
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.minAmount }}</td>
                            <td>
                              <strong>{{ item.maxAmount }}</strong>
                            </td>
                            <td>
                              <strong>{{ item.discount }}</strong>
                            </td>
                            <!-- <td @click.prevent.stop="showEditModal(item)">
                              <i class="fa fa-edit"></i>
                            </td> -->
                          </tr>
                        </tbody>
                      </table>
                      <div v-else>
                        <div class="alert alert-info" role="alert">
                          {{ translations.noRecords }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="action-buttons d-flex justify-content-between">
                <div>
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                    class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                  >
                    <i class="bx bx-trash text-4 me-2"></i>
                    {{ translations.delete }}
                  </button>
                </div>
                <div class="d-flex gap-3">
                  <router-link
                    exact
                    :to="{ name: 'EditCompany', params: {companyId: superBonus.companyId} }"
                    class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
                  >
                    {{ translations.cancel }}
                  </router-link>
                  <button
                    type="submit"
                    class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                    data-loading-text="Loading..."
                  >
                    <i class="bx bx-save text-4 me-2"></i> Spremi
                  </button>
                </div>
              </div>
            </form>
          </div>
          <!-- kraj novi superbonus -->
  
          <modal id="delete-modal">
            <h5 slot="header">
              <strong>Izbriši super bonus program</strong>
            </h5>
            <div slot="body">
              <span v-html="modalText"> </span>
            </div>
            <div slot="footer">
              <div class="row">
                <div class="col-md-12 text-end">
                  <button
                    type="button"
                    class="btn btn-primary px-4 mx-2"
                    @click.prevent.stop="deleteSuperBonus"
                    data-bs-dismiss="modal"
                  >
                    {{ translations.yes }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-default px-4"
                    data-bs-dismiss="modal"
                  >
                    {{ translations.no }}
                  </button>
                </div>
              </div>
            </div>
          </modal>
          <form @submit.prevent="addRange">
            <modal id="add-range" cssClass="modal-md-2">
              <header slot="header">
                <h2 class="card-title">Dodavanje stavke</h2>
              </header>
              <section slot="body">
                <div class="card-body">
  
                  <div class="form-group row">
                    <label
                      class="col-lg-4 control-label text-lg-end pt-2"
                      for="add-min-amount"
                      >Min vrijednost</label
                    >
                    <div class="col-lg-8">
                      <input
                        placeholder="Min vrijednost"
                        type="text"
                        class="form-control form-control-modern"
                        id="add-min-amount"
                        v-model.number="itemNewForm.minAmount"
                        readonly
                      />
                      <form-error
                        :model="$v.itemNewForm.minAmount"
                        :dirty="$v.itemNewForm.$dirty"
                        label='Min vrijednost'
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-lg-4 control-label text-lg-end pt-2"
                      for="add-max-amount"
                      >Max vrijednost</label
                    >
                    <div class="col-lg-8">
                      <input
                        placeholder="Max vrijednost"
                        type="text"
                        class="form-control form-control-modern"
                        id="add-max-amount"
                        v-model.number="itemNewForm.maxAmount"
                      />
                      <form-error
                        :model="$v.itemNewForm.maxAmount"
                        :dirty="$v.itemNewForm.$dirty"
                        label='Max vrijednost'
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-lg-4 control-label text-lg-end pt-2"
                      for="add-discount"
                      >Rabat</label
                    >
                    <div class="col-lg-8">
                      <input
                        placeholder="Rabat"
                        type="text"
                        class="form-control form-control-modern"
                        id="add-discount"
                        v-model.number="itemNewForm.discount"
                      />
                      <form-error
                        :model="$v.itemNewForm.discount"
                        :dirty="$v.itemNewForm.$dirty"
                        label='Rabat'
                      />
                    </div>
                  </div>
                </div>
              </section>
              <footer slot="footer">
                <div class="row">
                  <div class="col-md-12 text-end">
                    <!-- <button
                      class="btn btn-default modal-dismiss mx-2"
                      aria-label="Close"
                      @click="closeNewModal"
                    >
                      Odustani
                    </button> -->
                    <button class="btn btn-primary modal-confirm" type="submit">
                      Dodaj stavku
                    </button>
                  </div>
                </div>
              </footer>
            </modal>
          </form>
          <modal id="confirm-delete">
        <h5 slot="header">
          <strong>Ukloni odabrane stavke</strong>
        </h5>
        <div slot="body">
          Jeste li sigurni da želite ukloniti odabrane stavke?
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="removeRanges"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
        </div>
      </div>
      <!-- end: page -->
    </div>
  </template>
  
  <script>
  import Datepicker from 'vuejs-datepicker';
  import bs from 'vuejs-datepicker/dist/locale/translations/bs';
  import { format } from 'date-fns';
  
  import { translations } from '@/mixins';
  import superBonusValidations from './validation-schema/super-bonus';
  import itemValidation from './validation-schema/item-add-or-edit';
  import api from '@/services/api';
  import config from '@/config';
  import FormError from '../shared/form-errors/FormError.vue';
  import Modal from '../shared/modal/Modal.vue';
  
  export default {
    name: 'EditSuperBonus',
    mixins: [translations],
    components: {
      FormError,
      Datepicker,
      Modal,
    },
    validations: {
      superBonus: superBonusValidations,
      itemNewForm: itemValidation,
    },
    data() {
      return {
        posterUrl: null,
        baseUrl: config.baseUrl,
        loaded: false,
        selected: [],
        finishedMounted: false,
        itemNewForm: {
          minAmount: null,
          maxAmount: null,
          discount: null,
          generatedId: null,
        },
        itemEditForm: {
          minAmount: null,
          maxAmount: null,
          discount: null,
          generatedId: null,
        },
      };
    },
    computed: {
      progressWidth() {
      return this.progressPercentage;
    },
    progressPercentage() {
      return this.calculateSuperbonusProgress(this.superBonus?.totalAmount ?? 0);
    },
      bs() {
        return bs;
      },
      selectAll: {
        get() {
          return (
            this.superBonus?.ranges?.length > 0 &&
            this.selected.length === this.superBonus.ranges.length
          );
      },
        set(value) {
          this.selected = value
            ? this.superBonus.ranges.map(x => x.generatedId)
            : [];
      },
    },
      modalText() {
        return 'Jeste li sigurni da želite izbrisati super bonus program?';
      },
      superBonus() {
  return this.$store.getters.getCompanySuperBonus;
},
    lastMaxAmount() {
      if (!this.superBonus?.ranges?.length) return 0;
      return this.superBonus.ranges[this.superBonus.ranges.length - 1].maxAmount;
    },
      isFormValidSuperBonus() {
        return !this.$v.superBonus.$invalid;
      },
      isItemNewFormValid() {
        return !this.$v.itemNewForm.$invalid;
      },
    },
    mounted() {
     this.getSuperBonus();
    },
    methods: {
      calculateSuperbonusProgress(amount) {
      if (!this.lastMaxAmount) return 0;
      if (amount === this.lastMaxAmount) return 100;
      return (amount / this.lastMaxAmount) * 100;
    },
    formattedCurrentAmount() {
      const val = this.superBonus?.totalAmount ?? 0;
      return val >= 1000
        ? `${(val / 1000).toFixed(1).replace('.', ',')}k`
        : `${val.toFixed(2).replace('.', ',')}`;
    },
      deleteSuperBonus() {
      api
        .deleteSuperBonus(this.superBonus.id)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'EditCompany', params: { companyId: this.superBonus.companyId } });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    getSuperBonus() {
  this.$store.dispatch(
    'getCompanySuperBonus',
    this.$route.params.superbonusid
  )
  .then(() => {
    const data = this.$store.getters.getCompanySuperBonus;

    if (data?.ranges) {
      data.ranges.forEach((item, index) => {
        if (!item.generatedId) {
          this.$set(data.ranges, index, {
            ...item,
            generatedId: this.generateRandomId(),
          });
        }
      });
    }

    this.finishedMounted = true;
    this.loaded = true;
  })
  .catch((err) => {
    this.$toast.error(err.response.data.info);
  });
},
      openAddRangeModal() {
        $('#add-range').modal('show');
        if (this.superBonus.ranges.length > 0) {
          const maxAmount = this.superBonus.ranges.reduce(
            (max, range) => (range.maxAmount > max ? range.maxAmount : max),
            this.superBonus.ranges[0].maxAmount
          );
          this.itemNewForm.minAmount = maxAmount + 0.01;
        } else {
          this.itemNewForm.minAmount = 0;
        }
      },
      addRange() {
        this.$v.itemNewForm.$touch();
  
        if (!this.isItemNewFormValid) {
          this.$toast.error(this.translations.forms.notValid);
          return;
        }
  
        var areCorrectValues = this.superBonus.ranges.some(
          (x) =>
            (this.itemNewForm.minAmount <= x.minAmount &&
              this.itemNewForm.maxAmount >= x.maxAmount) ||
            (this.itemNewForm.maxAmount >= x.minAmount &&
              this.itemNewForm.maxAmount <= x.maxAmount) ||
            (this.itemNewForm.minAmount >= x.minAmount &&
              this.itemNewForm.minAmount <= x.maxAmount)
        );
  
        if (this.itemNewForm.minAmount >= this.itemNewForm.maxAmount) {
          this.$toast.error('Neispravne vrijednosti!');
        } else if (areCorrectValues) {
          this.$toast.error('Vrijednost već postoji u stavkama!');
        } else {
          this.itemNewForm.generatedId = this.generateRandomId();
          this.superBonus.ranges.push({ ...this.itemNewForm });
          this.closeNewModal();
        }

        this.updateSuperBonus();
      },
      showConfirmationModal() {
        if (this.selected.length) $('#confirm-delete').modal('show');
      },
      removeRanges() {
  const ranges = this.superBonus.ranges;

  // All selected
  if (this.selected.length === ranges.length) {
    this.superBonus.ranges = [];
    this.selected = [];
    this.updateSuperBonus();
    return;
  }

  const sorted = [...ranges].sort((a, b) => b.maxAmount - a.maxAmount);

  for (const range of sorted) {
    if (!this.selected.includes(range.generatedId))
      break;

    this.superBonus.ranges =
      this.superBonus.ranges.filter(
        x => x.generatedId !== range.generatedId
      );
  }

  // Check if user attempted removing a middle range
  const remainingSelected =
    this.selected.filter(id =>
      this.superBonus.ranges.some(x => x.generatedId === id)
    );

  if (remainingSelected.length) {
    this.$toast.error(
      'Molimo da prvo obrišete stavke sa maksimalnom vrijednošću'
    );
  }

  this.selected = [];

  this.updateSuperBonus();
},
      updateSuperBonus() {
        const { superBonus } = this;
  
        api.updateSuperBonus(this.$route.params.superbonusid, superBonus)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.selected = [];
          this.getSuperBonus();
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
      },
      closeNewModal() {
        $('#add-range').modal('hide');
        this.$v.itemNewForm.$reset();
        this.itemNewForm.maxAmount = null;
        this.itemNewForm.minAmount = null;
        this.itemNewForm.discount = null;
        this.itemNewForm.generatedId = null;
      },
      submitsuperBonus() {
        this.$v.superBonus.$touch();
  
        if (!this.isFormValidSuperBonus) {
          this.$toast.error(this.translations.forms.notValid);
          return;
        }
  
        const { superBonus } = this;
  
        api.updateCompanySuperBonus(this.$route.params.id, superBonus)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'EditCompany', params: { companyId: this.superBonus.companyId } });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
      },
      generateRandomId() {
        return -Math.ceil(Math.random() * 1000000);
      },
      customFormatter(date) {
        return format(date, 'dd.MM.yyyy.');
      },
    },
  };
  </script>
  
  <style lang="scss">
  .tab-content {
    background: transparent;
    padding: 0;
    box-shadow: none;
    border: none;
  }
  </style>
  
  <style scoped>
  .super-bonus-program {
    top: -15px;
    width: 100%;
    position: relative;
  }
  
  .super-bonus-title {
  font-size: 12px;
  font-weight: 700;
}

.progress-bar-wrapper {
  padding: 16px 20px 12px;
  background: #ffffff;
  border-radius: 8px;
  margin-right: 20px;
  border: 1px solid #ebebeb;
}

.progress-bar-container {
  position: relative;
  height: 75px;
  margin-bottom: 0;
}

.progress-bar {
  height: 20px;
  background-color: #e5e5e5;
  border-radius: 2px;
  position: absolute;
  top: 15px;
  left: 0;
  right: 0;
}

.progress-fill {
  height: 100%;
  background-color: #007bff;
  border-radius: 2px;
  position: absolute;
  top: 0;
  left: 0;
  transition: width 0.3s ease;
}

.current-amount-tooltip {
  position: absolute;
  top: -10px;
  transform: translateX(-50%);
  background: #1c3254;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 3;
}

.milestone {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.milestone-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e8e8e8;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  border: none;
  box-shadow: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  color: #aaaaaa;
  position: relative;
  z-index: 2;
  transition: background 0.3s ease, color 0.3s ease;
}

.milestone-circle.active {
  background: #1c3254;
  color: #ffffff;
  box-shadow: none;
}

.milestone-value {
  margin-top: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #555;
}
  </style>
  
  